// src/stores/usePaymentStore.ts
import { create } from 'zustand';
import axios from 'axios';

interface PaymentRequest {
  MerchantPaymentId: string;
  CardOwner: string;
  Pan: string;
  ExpiryMonth: string;
  ExpiryYear: string;
  Cvv: string;
  Amount: string;
  Currency: string;
  InstallmentCount: string;
  Customer: string;
  CustomerIp: string;
}

interface PaymentState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
  sendPayment: (payload: PaymentRequest) => Promise<string>;
}

const usePaymentStore = create<PaymentState>((set) => ({
  isLoading: false,
  error: null,
  success: false,

  sendPayment: async (payload) => {
    try {
      set({ isLoading: true, error: null, success: false });
  
      const formData = new FormData();
      for (const key in payload) {
        formData.append(key, payload[key as keyof PaymentRequest]);
      }
  
      const response = await axios.post(
        'https://pay.duyu.alter.net.tr/Home/Payment',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
  
      console.log('Payment Response:', response.data);
      set({ isLoading: false, success: true });
  
      return response.data;
    } catch (err: any) {
      set({
        error: err.message || 'Ödeme sırasında bir hata oluştu.',
        isLoading: false,
        success: false,
      });
  
      return ''; // veya throw err; isteğe bağlı
    }
  },
}));  

export default usePaymentStore;
